import { render, staticRenderFns } from "./PortfolioNoGap.vue?vue&type=template&id=7b984b52&"
import script from "./PortfolioNoGap.vue?vue&type=script&lang=js&"
export * from "./PortfolioNoGap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports